import { axiosInstance } from '../utils/axios';

export const getSettings = extraData =>
  axiosInstance.get('/users/me/settings', {
    ...extraData,
    params: {
      ...extraData?.params,
      refresh: Math.random(),
    },
  });

export const changePassword = ({ oldPassword, newPassword }, extraData) =>
  axiosInstance.post(
    '',
    {
      oldPassword,
      newPassword,
    },
    {
      ...extraData,
      params: {
        ...extraData?.params,
        method: 'account.updatePassword',
      },
    },
  );

export const putSettingsOption = ({ data, additionalPath }, extraData) =>
  axiosInstance
    .patch(`users/me/settings/${additionalPath}`, data, {
      ...extraData,
      params: {
        ...extraData?.params,
        refresh: Math.random(),
      },
    })
    .then(() =>
      axiosInstance.get('/users/me/settings', {
        ...extraData,
        params: {
          ...extraData?.params,
          refresh: Math.random(),
        },
      }),
    );
